import { toast, type ToastOptions } from 'vue3-toastify';
import { Error } from "@/a1/response-models";

export class AppToaster {
    info = (text: string) => {
        toast(text, {
            autoClose: 1000,
            position: toast.POSITION.TOP_LEFT,
            type: toast.TYPE.INFO
        } as ToastOptions);
    }

    success = (text: string) => {
        toast(text, {
            autoClose: 1000,
            position: toast.POSITION.TOP_LEFT,
            type: toast.TYPE.SUCCESS
        } as ToastOptions);
    }

    successOperation = () => {
        this.success("Operation Succeeded");
    }

    error = (content: string | Error) => {
        const message = (<Error>content)?.message  || content || "Oops, something went wrong";

        toast(`${message}`, {
            autoClose: 1000,
            position: toast.POSITION.TOP_LEFT,
            type: toast.TYPE.ERROR
        } as ToastOptions);
    }

    warn = (text: string) => {
        toast(text, {
            autoClose: 1000,
            position: toast.POSITION.TOP_LEFT,
            type: toast.TYPE.WARNING
        } as ToastOptions);
    }
}

const appToaster = new AppToaster();

export default appToaster;